import React from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Chip,
  Avatar,
} from "@mui/material";
import moment from "moment";
import { useTheme } from "@mui/material/styles";
import { getPriorityColor, getStatusColor } from "../../../util";

const QueryList = ({ queries, onQueryClick }) => {
  const theme = useTheme();

  if (!queries || queries.length === 0) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          flexGrow: 1,
        }}
      >
        <Typography sx={{ color: "grey", paddingY: 2 }}>
          No queries found
        </Typography>
      </Box>
    );
  }

  return (
    <List
      sx={{
        width: "100%",
        bgcolor: "background.paper",
        height: "100%",
        overflow: "auto",
      }}
    >
      {queries.map((query) => {
        const statusColor = getStatusColor(query.status);
        const priorityColor = getPriorityColor(query.priority);
        const createdByInitials = query.createdBy
          ? query.createdBy
              .split(" ")
              .map((n) => n[0])
              .join("")
              .toUpperCase()
              .substring(0, 2)
          : "?";

        return (
          <ListItem
            key={query.id}
            onClick={() => onQueryClick && onQueryClick(query)}
            sx={{
              cursor: onQueryClick ? 'pointer' : 'default',
              borderBottom: `1px solid ${theme.palette.divider}`,
              '&:hover': onQueryClick ? { backgroundColor: theme.palette.action.hover } : {},
            }}
          >
            <ListItemText
              primary={
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', mb: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600, flexGrow: 1 }}>
                    {query.tag || ''} - {query.title}
                  </Typography>
                  {query.description && (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        mb: 1,
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                      }}
                    >
                      {query.description}
                    </Typography>
                  )}
                </Box>
              }
              secondary={
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', mb: 1 }}>
                  <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexShrink: 0, width: '100%' }}>
                    <Chip
                      label={query.status}
                      size="small"
                      sx={{
                        backgroundColor: statusColor.bg,
                        color: statusColor.text,
                        fontWeight: 600,
                        fontSize: '0.7rem',
                      }}
                    />
                    <Chip
                      label={query.priority}
                      size="small"
                      sx={{
                        backgroundColor: priorityColor.bg,
                        color: priorityColor.text,
                        fontWeight: 600,
                        fontSize: '0.7rem',
                      }}
                    />
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                    <Avatar sx={{ width: 24, height: 24, fontSize: '0.7rem', bgcolor: theme.palette.primary.main }}>
                      {createdByInitials}
                    </Avatar>
                    <Typography variant="caption" color="text.secondary">
                      {query.createdBy || 'Unknown'}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ ml: 'auto' }}>
                      {moment(query.createdAt).format('MM/DD/YYYY hh:mm a')}
                    </Typography>
                  </Box>
                </Box>
              }
            />
          </ListItem>
        );
      })}
    </List>
  );
};

export default React.memo(QueryList);

